// extracted by mini-css-extract-plugin
export var buttonContainer = "_78-1";
export var fontSizeSelect = "_78-3";
export var formatSelect = "_78-2";
export var formats = "_78-4";
export var hidden = "_78-5";
export var icon = "_78-6";
export var select = "_78-0";